<template>
  <fn-slider
    class="brand-slider"
    navigation-outside-container="brand-slider-navigation"
    :loading="loading"
    :options="{
      slidesPerView: 4,
      watchOverflow: true,
      navigation: true,
      pagination: {
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        476: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        920: {
          slidesPerView: 4,
        },
      },
    }"
  >
    <fn-slide
      v-for="(slide, index) in slides"
      :key="index"
    >
      <fn-link
        no-arrow
        inline
        :href="slide.link.external ? slide.link.url : undefined"
        :to="!slide.link.external ? slide.link.url : undefined"
        :target="slide.link.target ? slide.link.target : undefined"
        :hide-from-crawl="slide.hide_for_google"
        class="link--brand"
        :aria-label="
          $t('accessibility.general.goToBrand', { brand: slide.image ? slide.image.title : slide.link.title })
        "
      >
        <fn-picture
          v-if="slide.image"
          :src="slide.image.url"
          :alt="slide.image.title || slide.link.title"
          :width="slide.image.width"
          :height="slide.image.height"
          class="brand-slider-image"
        />
      </fn-link>
    </fn-slide>
  </fn-slider>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    loading: true,
  }),
  mounted() {
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.brand-slider {
  min-height: 165px;
  position: relative;
  @include bp(m) {
    min-height: 151px;
  }
}
:deep(.brand-slider-image .picture-img) {
  max-height: 125px;
  width: auto;
}

:deep(.link.link--brand) {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.swiper-container--reached-beginning) {
  .swiper-button-prev {
    display: none;
  }
}

:deep(.swiper-container--reached-end) {
  .swiper-button-next {
    display: none;
  }
}

:deep(.swiper-button-prev.brand-slider-navigation),
:deep(.swiper-button-next.brand-slider-navigation) {
  top: calc(50% - 40px);
}

:deep(.link) {
  &:focus-visible {
    outline-offset: -2px;
  }
}
</style>
